var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloudy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1920,
    height: 500,
    preserveAspectRatio: "none",
    viewBox: "0 0 1920 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#SvgjsMask1143)",
    fill: "none"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 500,
    x: 0,
    y: 0,
    fill: "url(#SvgjsLinearGradient1144)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1984 500L0 500 L0 414.97Q36.62 355.59, 96 392.21Q169.71 305.92, 256 379.64Q320.51 348.15, 352 412.66Q423.97 324.63, 512 396.61Q550.61 339.22, 608 377.82Q674.85 348.66, 704 415.51Q777.57 329.07, 864 402.64Q899.44 342.08, 960 377.52Q1027.9 349.42, 1056 417.33Q1121.28 322.61, 1216 387.89Q1301.22 313.12, 1376 398.34Q1464.92 327.26, 1536 416.19Q1566.28 350.47, 1632 380.74Q1685.65 338.39, 1728 392.04Q1819.01 323.05, 1888 414.06Q1917.51 347.56, 1984 377.07z",
    fill: "#182f5d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2016 500L0 500 L0 443.67Q79.63 363.3, 160 442.93Q228.94 351.87, 320 420.8Q393.54 334.34, 480 407.88Q576.38 344.26, 640 440.65Q681.8 386.45, 736 428.25Q777.63 373.88, 832 415.52Q925.92 349.44, 992 443.37Q1066.64 358.01, 1152 432.65Q1187 371.64, 1248 406.64Q1315.31 377.95, 1344 445.26Q1418.05 359.31, 1504 433.35Q1577.83 347.18, 1664 421Q1737.46 334.46, 1824 407.92Q1888.66 376.58, 1920 441.24Q1959.55 384.78, 2016 424.33z",
    fill: "rgba(35, 77, 162, 1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1952 500L0 500 L0 441.09Q93.99 375.08, 160 469.07Q199.96 413.03, 256 453Q317.5 418.5, 352 480.01Q425.53 393.54, 512 467.07Q554.9 413.97, 608 456.87Q650.21 403.08, 704 445.29Q769.96 415.25, 800 481.21Q842.83 428.04, 896 470.87Q965.78 380.65, 1056 450.44Q1130.66 365.11, 1216 439.77Q1275.05 402.82, 1312 461.87Q1354.06 407.93, 1408 449.99Q1469.02 415.01, 1504 476.03Q1545.34 421.37, 1600 462.71Q1672.19 374.9, 1760 447.1Q1824.41 415.51, 1856 479.93Q1897.26 425.19, 1952 466.45z",
    fill: "#356cb1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2048 500L0 500 L0 469.31Q54.8 428.11, 96 482.9Q182.27 409.17, 256 495.44Q312.38 455.82, 352 512.19Q416.53 416.73, 512 481.26Q598.33 407.59, 672 493.91Q725.97 451.88, 768 505.85Q803.96 445.81, 864 481.78Q925.59 447.37, 960 508.96Q1020.56 409.51, 1120 470.07Q1177.44 431.51, 1216 488.96Q1305.07 418.02, 1376 507.09Q1406.84 441.92, 1472 472.76Q1562.26 403.02, 1632 493.29Q1686.33 451.62, 1728 505.94Q1793.99 411.93, 1888 477.92Q1974.12 404.04, 2048 490.16z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("mask", {
    id: "SvgjsMask1143"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 500,
    fill: "#ffffff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "18.49%",
    y1: "-71%",
    x2: "81.51%",
    y2: "171%",
    gradientUnits: "userSpaceOnUse",
    id: "SvgjsLinearGradient1144"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0e2a47",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00459e",
    offset: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudy);
export default __webpack_public_path__ + "static/media/cloudy.c37bed35e9ce97d391bef84f25116270.svg";
export { ForwardRef as ReactComponent };